// main slider
var $slider =  $('.js-slider');
function myHandler() {
  $slider.slick('slickPlay');
}
function playVideoSlide(slick,currentSlide,mute){

  var slide = $(slick.$slides.get(currentSlide));
  if(slide.find('video').length){
    if(slide.find('video')[0].readyState >= 2) {

        if(typeof mute !=="undefined")
          slide.find('video')[0].muted = true;
        else
          slide.find('video')[0].muted = false;

        slide.find('video')[0].play();
        $slider.slick('slickPause');

    } else {
      slide.find('video')[0].oncanplay = function() {
        if(typeof mute !=="undefined")
          slide.find('video')[0].muted = true;
        else
          slide.find('video')[0].muted = false;
        slide.find('video')[0].play();
        $slider.slick('slickPause');
      }
    }

    slide.find('video')[0].addEventListener('ended',function() {
      myHandler;
      $slider.slick('slickNext');
    },false);
  }
}

$slider.on('init reInit', function(event, slick) {
    $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
    $('.js-slider .slick-current').addClass('slider__item--visible');
    playVideoSlide(slick,0,1);
});
$slider.on('afterChange', function(event, slick, currentSlide) {
    var slide = $(slick.$slides.get(currentSlide));
    $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
    $('.js-slider .slick-current').addClass('slider__item--visible');
    playVideoSlide(slick,currentSlide,1);

    if(!slide.find('video').length){
      $slider.slick('slickPlay');
    }
});
$slider.on('beforeChange', function(event, slick, currentSlide,nextSlide) {
    var slide = $(slick.$slides.get(currentSlide));
    if(slide.find('video').length){
      slide.find('video')[0].pause();
    }
});

$('.gallerySlider').slick({
    arrows: true,
    speed: 700,
    fade: true,
    autoplaySpeed: 7000,
    dots: true,
    infinite: true,
    autoplay: true,
    prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"> Vorherige </button>',
    nextArrow: '<button type="button" class="slick-custom-arrow slick-next"> Nächste  </button>'
    // adaptiveHeight: true -> for videos
});

//slider--3 dots
if ( $('.js-slider--3').length ) {
    $('.js-slider--3 .slick-dots button').each(function(i) {
        i++;
        n=i;
        $(this).attr('data-number',++i).append('<span>0'+ n +'</span>');
    });
}
 // imageslider
 var elements = document.querySelectorAll('.js-sliderGallery');
 if ( elements.length>0){
   $('.js-sliderGallery').slick({
       arrows: true,
       speed: 700,
       autoplaySpeed: 7000,
       dots: true,
       infinite: true,
       autoplay: true,
       slidesPerRow: 5,
       rows: 2,
       responsive: [
         {
           breakpoint: 678,
           settings: {
             slidesPerRow: 2,
             rows: 2,
           }
         }
       ]
   });
 }

//offerSlider
var element = document.querySelector('.js-offerSlider');
if ( $('.js-offerSlider').length ){
  $('.js-offerSlider').slick({
      arrows: true,
      speed: 1400,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4
          }
        },
        {
          breakpoint: 800,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              dots: true,
              fade: false
          }
        },
        {
          breakpoint: 600,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: false,
              fade: true
          }
        }
      ]
  });
}

//logoSlider
if ( $('.js-logoSlider').length ){
  $('.js-logoSlider').slick({
      arrows: true,
      speed: 700,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
              slidesToShow: 4,
              slidesToScroll: 4
          }
        },
        {
          breakpoint: 900,
          adaptiveHeight: false,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 2
          }
        }
        ,
        {
          breakpoint: 600,
          adaptiveHeight: true,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1
          }
        }
      ]
  });
}
//productSlider
if ( $('.js-productSlider').length ) {
  $('.js-productSlider').slick({
      speed: 700,
      fade: true,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            dots: false
          }
        }
      ]
  });
}


//testimonials
if ( $('.homeTestimonials__slider').length ) {
  $('.homeTestimonials__slider').slick({
      speed: 700,
      fade: true,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      arrows: true,
      responsive: [
        {
          breakpoint: 1240,
          settings: {
            dots: false
          }
        }
      ]
  });
}
